import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../../../../Configuration/configuration.service';
import { BaseSearchModel } from '../../../../Data/Models/Common/base-search-model';
import { LocalStorageService } from '../../../../Shared/common/local-storage.service';
import { CharityDetailsModal, TrusteesDataModal } from '../addcharities/CharityDetailsModal';
import { CharityDataShareServiceService } from './charity-data-share-service.service';
import { ProfessionalAdvisorsCommonModel } from '../../../../Data/Models/Common/professional-advisors-common-model';

@Injectable({
  providedIn: 'root'
})
export class CharitiesService {
 
  SaveAccountingPeriod(AccountingPeriod: any): Observable<any>  {
    debugger
    const url = `${this.apiUrl}/AccountingPeriod/SaveAccountingPeriod`;
    return this.http.post<any>(url, AccountingPeriod);
  }

  private apiUrl = this.configService.getAPIBaseUrl(); // Base URL for your API

  constructor(private http: HttpClient, private configService: ConfigurationService, private dataShareService: CharityDataShareServiceService, private lsService: LocalStorageService) { }
  // Method to save charity details
  SaveCharityDetails(charityDetails: CharityDetailsModal): Observable<any> {
    debugger
    charityDetails.charity_Registration_Number = charityDetails?.charity_Registration_Number?.toString()
    charityDetails.company_Reference_Number = charityDetails?.company_Reference_Number ? charityDetails?.company_Reference_Number?.toString() : null
    charityDetails.country = charityDetails.country?.toString()
    charityDetails.county_Detail = charityDetails?.county_Detail?.toString();
    charityDetails.createdby = +charityDetails.createdby
    charityDetails.country_Detail = charityDetails.country_Detail?.toString()
   
    const url = `${this.apiUrl}/CharityDetails/SaveCharityDetails`;
    return this.http.post<any>(url, charityDetails);
  }

  GetAccountsGrid(CharityId: any): Observable<any> {
    debugger
    const url = this.apiUrl + '/AccountingPeriod/GetAccountsGrid?CharityId=';
    return this.http.get(url + CharityId);
  }

  GetCharityGrid(CentralUserId: any): Observable<any> {
    const url = this.apiUrl + '/CharityDetails/GetCharityGrid?CentralUserId=';
    return this.http.get(url + CentralUserId);
  }

  GetCharityGridtocheckduplicate(CentralUserId:any): Observable<any> {
    const url = this.apiUrl + '/CharityDetails/checkduplicatecharityData?CentralUserId=';
    return this.http.get(url + CentralUserId);
  }

  EditCharityDetails(CharityId: any): Observable<any> {
    debugger
    const url = this.apiUrl + '/CharityDetails/EditCharityDetails?CharityId=';
    return this.http.get(url + CharityId);
  }
  DeleteCharityDetails(CharityId: any): Observable<any> {
    debugger
    const url = this.apiUrl + '/CharityDetails/DeleteCharityDetails?CharityId=';
    return this.http.get<any>(url + CharityId);
  }
  deleteAccountPeriod(financialPeriodsID: any): Observable<any> {
    debugger
    const url = this.apiUrl + '/AccountingPeriod/DeleteAccountPeriod?financialPeriodsID=';
    return this.http.get<any>(url + financialPeriodsID);
  }
  istarreportselected(financialPeriodsID: any): Observable<any> {
    debugger
    const url = this.apiUrl + '/AccountingPeriod/IsTAR?financialPeriodsID=';
    return this.http.get<any>(url + financialPeriodsID);
  }
  GetSearchCharityByRegNumber(RegisteredNumber: any): Observable<any> {
    debugger
    const url = this.apiUrl + '/CharityCommission/GetSearchCharityByRegNumber?RegisteredNumber=';
    return this.http.get(url + RegisteredNumber);
  }
  CharityAccountArInformation(RegisteredNumber: any, suffix: any, financialPeriodsID: any, centralUserId?: any, UserId?: any, currentperiod?:any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/CharityCommission/CharityAccountArInformation?RegisteredNumber=` + RegisteredNumber + '&suffix=' + 0 +
      '&financialPeriodsID=' + financialPeriodsID + '&centralUserId=' + centralUserId + '&UserId=' + UserId + '&currentperiod=' + currentperiod;
    //const url = `${this.apiUrl}/CharityCommission/CharityAccountArInformation`
    //  + `?RegisteredNumber=${+RegisteredNumber}`
    //  + `&suffix=0`
    //  + `&financialPeriodsID=${+financialPeriodsID}`

    return this.http.get(url );
  }
  searchCharityName(charityName: string): Observable<any> {
    debugger
    const url = this.apiUrl + '/CharityCommission/searchCharityName?charityname=';
    return this.http.get(url + charityName);
  }
 

  GetAllCharityDetailsV2(registeredNumber: number, suffix: number = 0): Observable<any> {
    const url = `${this.apiUrl}/CharityCommission/GetAllCharityDetailsV2?RegisteredNumber=${registeredNumber}&suffix=${suffix}`;
    return this.http.get(url);
  }
  EditAccountPeriod(financialPeriodsID: any): Observable<any> {
    debugger
    const url = this.apiUrl + '/AccountingPeriod/EditAccountPeriod?financialPeriodsID=';
    return this.http.get<any>(url + financialPeriodsID);
  }
 GetCountries(): Observable<any> {
    debugger
    const url = this.apiUrl + '/CharityDetails/GetCountries';
    return this.http.get(url );
  }
  getCharites(filter: any, sortOrder: any, sortBy: any, pageNumber: any, pageSize: any): Observable<CharityDetailsModal[]> {
    debugger;
    //Charity main grid method
    const currentUser = localStorage.getItem('CentralUserId');
    //if (currentUser) {
    //  const parsedUser = JSON.parse(currentUser);
    //  var centralUserID = parsedUser.centralUserID;

    //}
    let params = new HttpParams()
      .set('filter', filter)
      .set('sortOrder', sortOrder)
      .set('sortBy', sortBy)
      .set('pageNumber', pageNumber ? pageNumber.toString() : "0")
      .set('pageSize', pageSize ? pageSize.toString() : "0")
      .set('id', currentUser ? currentUser:0 )
      .set('UserID', localStorage['userID'] )
    if ((this.dataShareService.charityFilterDetails)) {

      params = params
        .set('charitiesFilterModel.type', this.dataShareService.charityFilterDetails.type)
        .set('charitiesFilterModel.jurisdiction', this.dataShareService.charityFilterDetails.jurisdiction)
        .set('charitiesFilterModel.status', this.dataShareService.charityFilterDetails.status)
        .set('charitiesFilterModel.accountingMethod', this.dataShareService.charityFilterDetails.accounting_Method);
    }
    return this.http.get<BaseSearchModel<CharityDetailsModal>>(this.apiUrl + '/CharityDetails/getcharities', { params}


    ).pipe(
      tap((res: BaseSearchModel<CharityDetailsModal>) => {
        this.dataShareService.setCharityList(res);//undo

      }),
      map(res => res["entity"]?.sort((a, b) =>
          a.charity_Name?.toLowerCase().localeCompare(b.charity_Name?.toLowerCase())
        )
      ),
    );
}
  getProfessionalAdvisorDetails(charityId: any): Observable<BaseSearchModel<ProfessionalAdvisorsCommonModel>> {
    debugger
    return this.http.get<BaseSearchModel<ProfessionalAdvisorsCommonModel>>(this.apiUrl + '/CharityDetails/getProfessionalAdvisorDetails?id='+charityId)
  }
  deleteProfessionalAdvisorDetails(advisorid: any): Observable<any> {
    debugger
    return this.http.get(this.apiUrl + '/CharityDetails/deleteProfessionalAdvisorDetails?id=' + advisorid)
  }
  saveAdvisor(advisorDetails: ProfessionalAdvisorsCommonModel): Observable<any> {
    const url = `${this.apiUrl}/CharityDetails/saveAdvisor`;
    return this.http.post<any>(url, advisorDetails);
  }

  SaveTrusteesData(trusteesDataModal: TrusteesDataModal): Observable<any> {
    debugger
    const url = `${this.apiUrl}/CharityDetails/SaveTrusteesData`;
    return this.http.post(url, trusteesDataModal);
  }
  saveEmailTemplate(TemplatesData: any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/Preference/saveEmailTemplate`;
    //const url = `${this.apiUrl}//api/Preference/saveEmailTemplate`;
    return this.http.post(url, TemplatesData);
  }
  GetEmailTemplate(id: any,type:any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/Preference/GetEmailTemplate?id=${id}&type=${type}`;
    return this.http.get(url);
  }
  getPresenterInfo(id: any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/Preference/GetPresenter?id=`;
    return this.http.get(url+id);
  }
  SavePresenterInfo(details:any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/Preference/SavePresenter`;
    //const url = `${this.apiUrl}//api/Preference/saveEmailTemplate`;
    return this.http.post(url, details);
  }
  Getbasicinfo(CharityId: any, PeriodId: any): Observable<any> {

    const url = this.apiUrl + '/AccountingPeriod/GetBasicinformation?CharityId=' + CharityId + '&financialPeriodsID=' + PeriodId;
    return this.http.get(url);
  }

  GetCharityTrusteeInformationV2(registration_Number: number, suffix: number): Observable<any> {
    debugger
    const url = `${this.apiUrl}/CharityTrustees/GetCharityTrusteeInformationV2?RegisteredNumber=${registration_Number}&suffix=${suffix}`;
    return this.http.get(url);
  }
  GetTrusteeDetails(charity_ID: number): Observable<any> {
    debugger
    const url = `${this.apiUrl}/CharityDetails/getTrusteeDetails?id=${charity_ID}`;
    return this.http.get(url);
  }
  DeleteTrusteeDetails(Trustee_id :any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/CharityDetails/deleteTrusteeDetails?id=${Trustee_id}`;
    return this.http.get(url);
  }


  CharitiesForUserInformatiom(UserID: any): Observable<any> {
    const url = this.apiUrl + '/CharityDetails/CharitiesForUserInformatiom?UserID=';
    return this.http.get(url + UserID);
  }


}


